module.exports = {
    isElectron: window.__env.isElectron
};